import { FC } from 'react';
import { TextProps } from '@chakra-ui/react';
import { CbTextCollapse } from '../CbTextCollapse';
import { RewardsActivityCardType } from '../../types/RewardsActivityCard';
export interface CbRewardsActivityReasonProps extends TextProps {
  isMobile?: boolean;
  reason: RewardsActivityCardType['reason'];
}
export const CbRewardsActivityReason: FC<CbRewardsActivityReasonProps> = ({
  isMobile,
  reason,
  ...props
}) => {
  return <CbTextCollapse color="text.secondary" fontSize="sm" maxCharacterLength={isMobile ? 54 : 97} text={reason || ''} {...props} data-sentry-element="CbTextCollapse" data-sentry-component="CbRewardsActivityReason" data-sentry-source-file="CbRewardsActivityReason.tsx" />;
};